import React from 'react';
import {useNavigate, useSearchParams} from "react-router-dom";

function TableTitleNew({title, tabs, extra}) {

    const path = window.location.pathname
    const path2 = path.split("/")[2]
    const [searchParams] = useSearchParams()
    const navigate = useNavigate()

    const removeSearchParams = () =>{
        searchParams.delete("weightStation")
        navigate(`?${searchParams.toString()}`)
    }
    return (
        <div
            className={"bg-white w-full px-[24px] py-[18.5px] rounded-tl-[12px] rounded-tr-[12px]"} //chinh [padding cho table ]
            style={{
                borderRight: "1px solid #EAECF0",
                borderLeft: "1px solid #EAECF0",
                borderTop: "1px solid #EAECF0",
                borderBottom: "1px solid #EAECF0",
                borderTopRightRadius: path2 !== "report-weighing-station" ? 12 : 0,
                borderTopLeftRadius: path2 !== "report-weighing-station" ? 12 : 0
            }}
            id={"header-filter"}
        >
            <div className="flex items-center">
                <div>
                    {title ? <h3 className={"text-lg m-0 font-medium cursor-pointer"}
                                 style={{color : searchParams.get("weightStation") ? "rgb(251,105,0)" : "#101828"}}
                    onClick={()=>removeSearchParams()}>
                        {title}
                    </h3> : null}
                    {tabs}
                </div>
                {extra}
            </div>
        </div>
    );
}

export default TableTitleNew;
